(() => {
  function init(root) {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    const items = [...root.querySelectorAll('[data-faq-item]')];
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const animations = new WeakMap();
    function setOpen(item, open, animate = true) {
      const from = item.getBoundingClientRect().height;
      animations.get(item)?.cancel();
      animations.delete(item);
      item.style.height = '';
      item.style.overflow = '';
      item.dataset.expanded = String(open);
      item.querySelector('summary').setAttribute('aria-expanded', String(open));
      if (!animate || reduceMotion.matches) { item.open = open; return; }
      item.open = true;
      const to = open ? item.getBoundingClientRect().height : item.querySelector('summary').getBoundingClientRect().height;
      item.style.overflow = 'hidden';
      const animation = item.animate({height: [`${from}px`, `${to}px`]}, {duration: 400, easing: 'cubic-bezier(.35,.2,.2,1)'});
      animations.set(item, animation);
      animation.onfinish = () => {
        item.open = open;
        item.style.overflow = '';
        animations.delete(item);
      };
    }
    items.forEach(item => {
      item.dataset.expanded = String(item.open);
      const summary = item.querySelector('summary');
      summary.setAttribute('aria-expanded', String(item.open));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const open = item.dataset.expanded !== 'true';
        if (open) item.closest('[data-faq-group]').querySelectorAll('[data-faq-item]').forEach(other => {
          if (other !== item && other.dataset.expanded === 'true') setOpen(other, false);
        });
        setOpen(item, open);
      });
    });
    document.addEventListener('shopify:block:select', event => {
      const item = event.target.closest('[data-faq-item]');
      if (item && root.contains(item)) setOpen(item, true, false);
    });
  }
  const initAll = () => document.querySelectorAll('[data-shg-faq]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
